import router, { constantRoutes, asyncRoutes, resetRouter } from '@/router'
import Layout from '@/layout'

import { Message } from 'element-ui'
import { filterRoute } from '@/utils/auth'
import { getMyListBook } from '../../api/account_book'
import { getAddonCompanyAllList } from '@/api/addon-company'
const state = {
  token: '',
  routes: constantRoutes,
  authRoutes: constantRoutes,
  jurisdiction: [],
  addonPermissions: [],
  user: {},
  book: [],
  bookInfo: {},
  activeMenu: '',
  siteName: '',
  searchParams: null,
  addonCenter: [],
  allCompany: []
}

const mutations = {
  SET_TOKEN: (state, data) => {
    state.token = data.token
  },
  SET_ROUTES: (state, data) => {
    state.routes = data.routes
  },
  SET_AUTH_ROUTES: (state, data) => {
    state.authRoutes = data.routes
  },
  SET_JUR: (state, data) => {
    state.jurisdiction = data.jurisdiction
    state.addonPermissions = data.addonPermissions
  },
  SET_USER: (state, data) => {
    state.user = data.user
  },
  SET_BOOK: (state, data) => {
    state.book = data.book
  },
  SET_BOOK_INFO: (state, data) => {
    state.bookInfo = data.bookInfo
  },
  SET_SITE_NAME: (state, data) => {
    state.siteName = data.siteName
  },
  SET_SEARCH_PARAMS: (state, data) => {
    state.searchParams = data.searchParams
  },
  SET_ACTIVE_MENU: (state, data) => {
    state.activeMenu = data.activeMenu
  },
  SET_ADDON_CENTER: (state, data) => {
    state.addonCenter = data.addonCenter
  },
  SET_ALL_COMPANY: (state, data) => {
    state.allCompany = data
  }
}

const actions = {
  // 设置token
  setToken(context, data) {
    context.commit({
      type: 'SET_TOKEN',
      token: data.token
    })
  },

  // 设置siteName
  setSiteName(context, data) {
    context.commit({
      type: 'SET_SITE_NAME',
      siteName: data.siteName
    })
  },

  // 设置路由
  setRoutes(context, data) {
    context.commit({
      type: 'SET_ROUTES',
      routes: data.routes
    })
  },
  // FIXME: 后续移除
  // 设置路由
  setAuthRoutes(context, data) {
    context.commit({
      type: 'SET_AUTH_ROUTES',
      routes: data.routes
    })
  },

  // 员工权限
  setJurisdiction(context, data) {
    context.commit({
      type: 'SET_JUR',
      jurisdiction: data.jurisdiction,
      addonPermissions: data.addonPermissions
    })
  },

  // 超级管理员
  setUser(context, data) {
    context.commit({
      type: 'SET_USER',
      user: data.user
    })
  },

  // 存储账本
  setBook(context, data) {
    context.commit({
      type: 'SET_BOOK',
      book: data.book
    })
  },

  // 存储初始账本数据
  setBookInfo(context, data) {
    context.commit({
      type: 'SET_BOOK_INFO',
      bookInfo: data.bookInfo
    })
  },

  // 存储搜索数据
  setSearchParams(context, data) {
    context.commit({
      type: 'SET_SEARCH_PARAMS',
      searchParams: data.searchParams
    })
  },

  // 存储点击菜单
  setActiveMenu(context, data) {
    context.commit({
      type: 'SET_ACTIVE_MENU',
      activeMenu: data.activeMenu
    })
  },
  // 存储应用中心
  setAddonCenter(context, data) {
    context.commit({
      type: 'SET_ADDON_CENTER',
      addonCenter: data.addonCenter
    })
  },

  // 退出登录
  logout({ commit, dispatch }) {
    commit('SET_TOKEN', '')
    sessionStorage.clear()
    localStorage.clear()
    dispatch('setRoutes', { routes: [] })
    // FIXME: 后续移除
    dispatch('setAuthRoutes', { authRoutes: [] })
    dispatch('tagsView/delAllViews', null, { root: true })
    dispatch('setJurisdiction', {
      jurisdiction: [],
      addonPermissions: []
    })
    resetRouter()
  },

  // 设置权限相关
  setPermissionAuth({ dispatch }, data) {
    return new Promise((resolve) => {
      const _jurisdiction = []
      const _list = data.permissions || []
      _list.forEach((el) => {
        _jurisdiction.push(el.permissionName)
      })

      if (_jurisdiction.length === 0) {
        // alert('你没有权限进入系统,请联系管理员!', '提示', {
        //   confirmButtonText: '确定',
        //   callback: (action) => {
        //     this.loading = false
        //   }
        // })
        Message.error('你没有权限进入系统,请联系管理员!')
      } else {
        dispatch({
          type: 'setJurisdiction',
          jurisdiction: _jurisdiction,
          addonPermissions: data.addonPermissions || []
        })
      }
      resolve()
    })
  },
  // 请求current接口后，过滤设置权限路由
  setRouteAuth({ dispatch, state }) {
    return new Promise((resolve) => {
      // 循环CRM
      state.allCompany.forEach(item => {
        const isExist = asyncRoutes.some(route => route.path === `/company/${item.id}`)
        if (!isExist) {
          const route = {
            path: `/company/${item.id}`,
            redirect: '/company/crm_statistics',
            isChildren: true,
            component: Layout,
            meta: { title: item.name, icon: 'shopping-bag', noCache: true },
            hidden: false,
            children: [{
              path: 'crm_statistics',
              type: [`company.workBoard.${item.id}`],
              hidden: false,
              name: `CrmStatistics/${item.id}`,
              props: { crmId: item.id },
              component: () =>
                import('@/views/company/crm_statistics'),
              meta: { title: '工作看板', icon: 'shopping-bag', noCache: true, tagTitle: `工作看板-${item.name}` }
            },
            {
              path: 'sale_dashboard',
              type: [`company.saleBoard.${item.id}`],
              hidden: false,
              name: `SaleDashboard/${item.id}`,
              props: { crmId: item.id },
              component: () =>
                import('@/views/company/sale_dashboard'),
              meta: { title: '销售看板', icon: 'shopping-bag', noCache: true, tagTitle: `销售看板-${item.name}` }
            },
            {
              path: 'company_all',
              type: [`company.companyAll.${item.id}`],
              hidden: false,
              name: `CompanyAll/${item.id}`,
              props: { crmId: item.id },
              component: () =>
                import('@/views/company/company_all'),
              meta: { title: '全部客户', icon: 'shopping-bag', noCache: true, tagTitle: `全部客户-${item.name}` }
            },
            {
              path: 'company_my',
              type: [`company.viewCompany.${item.id}`],
              hidden: false,
              name: `CompanyMy/${item.id}`,
              props: { crmId: item.id },
              component: () =>
                import('@/views/company/company_my'),
              meta: { title: '我的客户', icon: 'shopping-bag', noCache: true, tagTitle: `我的客户-${item.name}` }
            },
            {
              path: 'company_public',
              type: [`company.companyOpen.${item.id}`],
              hidden: false,
              name: `CompanyPublic/${item.id}`,
              props: { crmId: item.id },
              component: () =>
                import('@/views/company/company_public'),
              meta: { title: '公共客户', icon: 'shopping-bag', noCache: true, tagTitle: `公共客户-${item.name}` }
            },
            {
              path: 'company_follow',
              type: [`company.companyFollow.${item.id}`],
              hidden: false,
              name: `CompanyFollow/${item.id}`,
              props: { crmId: item.id },
              component: () =>
                import('@/views/company/company_follow'),
              meta: { title: '跟进记录', icon: 'shopping-bag', noCache: true, tagTitle: `跟进记录-${item.name}` }
            },
            {
              path: 'crm_targetPlan',
              type: [`company.plan.target.${item.id}`],
              hidden: false,
              name: `CompanyTargetPlan/${item.id}`,
              props: { crmId: item.id },
              component: () =>
                import('@/views/company/crm_targetPlan'),
              meta: { title: '目标计划', icon: '', noCache: true, tagTitle: `目标计划-${item.name}` }
            },
            {
              path: 'company_label',
              type: [`company.companyLabel.${item.id}`],
              hidden: false,
              name: `CompanyLabel/${item.id}`,
              props: { crmId: item.id },
              component: () =>
                import('@/views/company/company_label'),
              meta: { title: '标签管理', icon: 'shopping-bag', noCache: true, tagTitle: `标签管理-${item.name}` }
            },
            {
              path: 'company_setting',
              type: [`company.configCompany.${item.id}`, `company.jurisdiction.view.${item.id}`],
              hidden: false,
              name: `CompanySetting/${item.id}`,
              props: { crmId: item.id },
              component: () =>
                import('@/views/company/company_setting'),
              meta: { title: '设置', icon: 'shopping-bag', noCache: true, tagTitle: `设置-${item.name}` }
            }
            ]
          }
          asyncRoutes.splice(6, 0, route)
        }
      })
      // FIXME: 暂时屏蔽路由访问权限
      const jurisdiction = state?.jurisdiction || []
      const filterAsyncAuthRoutes = filterRoute([...asyncRoutes], jurisdiction)
      dispatch({
        type: 'setAuthRoutes',
        routes: [...filterAsyncAuthRoutes, ...constantRoutes]
      })
      const filterAsyncRoutes = [...asyncRoutes]

      router.addRoutes([...filterAsyncRoutes])
      dispatch({
        type: 'setRoutes',
        routes: [...filterAsyncRoutes, ...constantRoutes]
      })
      resolve({ filterAsyncRoutes, constantRoutes })
    })
  },
  // 设置当前我的账本
  setMyBooks({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      return getMyListBook(data).then((res) => {
        const _listBook = res.data || []
        dispatch({
          type: 'setBook',
          book: _listBook
        })

        if (data.defaultSubareaId) {
          for (let i = 0; i < _listBook.length; i++) {
            if (_listBook[i].id === data.defaultSubareaId) {
              dispatch({
                type: 'setBookInfo',
                bookInfo: _listBook[i]
              })
              break
            }
          }
        } else {
          dispatch({
            type: 'setBookInfo',
            bookInfo: _listBook[0]
          })
        }
        resolve()
      }).catch(error => {
        console.error(error)
        reject(error)
      })
    })
  },
  // 获取开启的CRM
  setAllCompany({ commit, dispatch }) {
    getAddonCompanyAllList().then((res) => {
      if (res.code === 200) {
        commit('SET_ALL_COMPANY', res.data)
        dispatch('setRouteAuth')
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
